import { render, staticRenderFns } from "./typeWorks.vue?vue&type=template&id=e0bd7ab2"
import script from "./typeWorks.vue?vue&type=script&lang=js"
export * from "./typeWorks.vue?vue&type=script&lang=js"
import style0 from "./typeWorks.vue?vue&type=style&index=0&id=e0bd7ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports